<div [formGroup]="loginForm" class="page-root">
  <div class="column-gap-m">
    <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
      <mat-label>{{ "form.label.email" | transloco }}</mat-label>
      <input formControlName="email" matInput>
      <mat-icon matSuffix>email</mat-icon>
    </mat-form-field>

    <mat-form-field hideRequiredMarker subscriptSizing="dynamic">
      <mat-label>{{ "form.label.password" | transloco }}</mat-label>
      <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput>
      <app-icon-button (click)="togglePasswordVisibility()" [icon]="hidePassword ? 'visibility_off' : 'visibility'" matSuffix/>
    </mat-form-field>

    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }

    <div class="actions">
      <app-text-button (click)="login()" [text]="'login.button' | transloco" colorVariant="primary" leadingIcon="logout" type="rounded"/>
    </div>
  </div>

  <div>
    <div class="body-text-small-bold">{{ "login.navigation.registration.description" | transloco }}</div>
    <button (click)="register()" class="link-button">{{ "login.navigation.registration.button" | transloco }}</button>
    <br><br>
    <div class="body-text-small-bold">{{ "login.navigation.passwordReset.description" | transloco }}</div>
    <button (click)="resetPassword()" class="link-button">{{ "login.navigation.passwordReset.button" | transloco }}</button>
  </div>
</div>
